export default __webpack_public_path__ + "static/media/s_wdt_c_2.c70150ee.mp3";